// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/whitebtn.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.frame-four-container {
  --grid-row-gap: 50px;
  --title-font-size: 180px;
  --title-padding-top: 50px;

  background-color: black;
  color: #6f6f6f;
  font-family: PP-Nuebit;
}

.frame-four {
  padding: 10vw;
  position: relative;
  display: grid;
  grid-template-rows: min-content 1fr;
  grid-template-columns: 1fr 1fr;
  column-gap: 15px;
  row-gap: var(--grid-row-gap);

  grid-template-areas:
    "head head"
    "leftbar main";
}

.frame-four-title {
  grid-area: head;
  padding-top: var(--title-padding-top);
  background-color: black;
}

.frame-four-title > h1 {
  font-size: var(--title-font-size);
  transition: all 0.5s ease;
}

.frame-four-left {
  grid-area: leftbar;

  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8vh;
  height: -moz-fit-content;
  height: fit-content;
  position: sticky;
  top: 0px;
  padding: 0 7vw;
  text-align: start;
  padding-top: 3vh;
}

.frame-four-left .section {
  display: flex;
  flex-direction: column;
  gap: 15px;
  transition: all 0.5s ease;
  max-width: 400px;
}

.section > h2 {
  font-size: 4.5vw;
  margin: unset;
  line-height: 80%;
}

.section > span {
  font-size: 2vw;
}

.frame-four-right {
  grid-area: main;

  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 10vw;
}

.frame-four-right {
  padding: 0 5%;
  font-size: 1.8vw;
  font-family: "N27";
  text-align: start;
  padding-top: 50vh;
}

.scroll-section {
  display: flex;
  flex-direction: column;
  gap: 30px;
  transition: all 0.5s ease;
}

.active {
  color: white;
}

.contact-us-btn {
  /* margin: 10px; */
  padding: 10px 10px 15px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: 50px;
  text-align: left;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  font-style: italic;
  font-weight: bold;
  font-size: 24px;
}

.contact-us-btn:hover {
  transform: scale(1.05);
}`, "",{"version":3,"sources":["webpack://./src/components/Frame4/Frame4.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,yBAAyB;;EAEzB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;;EAE5B;;kBAEgB;AAClB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;;EAElB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,QAAQ;EACR,wBAAmB;EAAnB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;;EAEf,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,yDAAyD;EACzD,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".frame-four-container {\n  --grid-row-gap: 50px;\n  --title-font-size: 180px;\n  --title-padding-top: 50px;\n\n  background-color: black;\n  color: #6f6f6f;\n  font-family: PP-Nuebit;\n}\n\n.frame-four {\n  padding: 10vw;\n  position: relative;\n  display: grid;\n  grid-template-rows: min-content 1fr;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 15px;\n  row-gap: var(--grid-row-gap);\n\n  grid-template-areas:\n    \"head head\"\n    \"leftbar main\";\n}\n\n.frame-four-title {\n  grid-area: head;\n  padding-top: var(--title-padding-top);\n  background-color: black;\n}\n\n.frame-four-title > h1 {\n  font-size: var(--title-font-size);\n  transition: all 0.5s ease;\n}\n\n.frame-four-left {\n  grid-area: leftbar;\n\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 8vh;\n  height: fit-content;\n  position: sticky;\n  top: 0px;\n  padding: 0 7vw;\n  text-align: start;\n  padding-top: 3vh;\n}\n\n.frame-four-left .section {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  transition: all 0.5s ease;\n  max-width: 400px;\n}\n\n.section > h2 {\n  font-size: 4.5vw;\n  margin: unset;\n  line-height: 80%;\n}\n\n.section > span {\n  font-size: 2vw;\n}\n\n.frame-four-right {\n  grid-area: main;\n\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10vw;\n}\n\n.frame-four-right {\n  padding: 0 5%;\n  font-size: 1.8vw;\n  font-family: \"N27\";\n  text-align: start;\n  padding-top: 50vh;\n}\n\n.scroll-section {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  transition: all 0.5s ease;\n}\n\n.active {\n  color: white;\n}\n\n.contact-us-btn {\n  /* margin: 10px; */\n  padding: 10px 10px 15px 10px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  justify-content: center;\n  width: 300px;\n  height: 50px;\n  text-align: left;\n  background-image: url(\"../../assets/Images/whitebtn.png\");\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  cursor: pointer;\n  font-style: italic;\n  font-weight: bold;\n  font-size: 24px;\n}\n\n.contact-us-btn:hover {\n  transform: scale(1.05);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
